import {API_URL } from '../constants/index.js';
import {
    CATEGORY,
    CATEGORY_SUCCESS,
    CATEGORY_ERROR,
    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    ADD_CATEGORY_ERROR,
    CATEGORY_ICONS,
    CATEGORY_ICONS_SUCCESS,
    CATEGORY_ICONS_ERROR,
    UPDATE_CATEGORY,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_ERROR,
    DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_ERROR,

    ICONS,
    ICONS_ERROR, 
    ICONS_SUCCESS
} from '../constants/categoryConstants';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';

//#region GET CATEGORY
export function getCategory(data) {
    return {
        type: CATEGORY,
        data
    }
};

export function getCategorySuccess(data) {
    return {
        type: CATEGORY_SUCCESS,
        data
    }
};

export function getCategoryError(data) {
    return {
        type: CATEGORY_ERROR,
        data
    }
};

export function GetAllCategories(idCommunity) {
    return dispatch => {
        dispatch(getCategory());
        
        fetch(API_URL+'categories/categories',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getCategorySuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCategoryError(error));

            })
    }
};


export function GetCategoriesByCommunityId(idCommunity) {
    return dispatch => {
        dispatch(getCategory());
        
        fetch(API_URL+'categories/categoriesByCommunity/'+idCommunity,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {

                if(res.message){
                    dispatch(getCategoryError(res));    
                } else{

                    dispatch(getCategorySuccess(res));
                }
                return res;
            })
            .catch(error => {
                dispatch(getCategoryError(error));

            })
    }
};

//#endregion

//#region  Add Category
export function addCategory(data) {
    return {
        type: ADD_CATEGORY,
        data
    }
};

export function addCategorySuccess(data) {
    return {
        type: ADD_CATEGORY_SUCCESS,
        data
    }
};

export function addCategoryError(data) {
    return {
        type: ADD_CATEGORY_ERROR,
        data
    }
};

export function AddCategory(data) {
    return dispatch => {
        dispatch(addCategory());

        fetch(API_URL+'categories/category',
            {
                body:JSON.stringify(data),
                method: 'POST',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {


                const message = `The category has been added successfully`

                sweetAlert('success',message,'alert_Add_Category_Success');

                dispatch(addCategorySuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(addCategoryError(error));

            })
    }
};
//#endregion

//#region  update Category
export function updateCategory(data) {
    return {
        type: UPDATE_CATEGORY,
        data
    }
};

export function updateCategorySuccess(data) {
    return {
        type: UPDATE_CATEGORY_SUCCESS,
        data
    }
};

export function updateCategoryError(error) {
    return {
        type: UPDATE_CATEGORY_ERROR,
        error
    }
};

export function UpdateCategory(id,data) {
    return dispatch => {
        dispatch(updateCategory());

        fetch(API_URL+'categories/category/' + id,
            {
                body:JSON.stringify(data),
                method: 'PUT',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => {res.json()})
            .then(res => {
                const message = `The category has been updated successfully`

                sweetAlert('success',message,'alert_Category_Update_Success');

                dispatch(updateCategorySuccess(data));
                
                return res;
            })
            .catch(error => {
                dispatch(updateCategoryError(error));

            })
    }
};
//#endregion


//#region  delete Category
export function deleteCategory() {
    return {
        type: DELETE_CATEGORY,
        
    }
};

export function deleteCategorySuccess(id) {
    return {
        type: DELETE_CATEGORY_SUCCESS,
        data:id

    }
};

export function deleteCategoryError(error) {
    return {
        type: DELETE_CATEGORY_ERROR,
        error
    }
};

export function DeleteCategory(id) {
    return dispatch => {
        dispatch(deleteCategory());

       
        fetch(API_URL+'categories/category/' + id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => {res.json();})
            .then(res => {
                const message = `The category has been deleted successfully`

                sweetAlert('success',message,'alert_Category_Delete_Success');

                dispatch(deleteCategorySuccess(id));

            })
            .catch(error => {

                dispatch(deleteCategoryError(error));
              
                const message = `An error has occured while deleting the category`

                sweetAlert('error',message,'alert_Category_Delete_Error');
            })
    }
};
//#endregion

//#region  ICONS
//#region  Add Category
export function getCategoryIcons(data) {
    return {
        type: CATEGORY_ICONS,
        data
    }
};

export function getCategoryIconsSuccess(data) {
    return {
        type: CATEGORY_ICONS_SUCCESS,
        data
    }
};

export function getCategoryIconsError(data) {
    return {
        type: CATEGORY_ICONS_ERROR,
        data
    }
};

export function GetCategoryIcons(data) {
    return dispatch => {
        dispatch(getCategoryIcons());
        
        fetch(API_URL+'icons/category',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getCategoryIconsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCategoryIconsError(error));

            })
    }
};


export function getIcons(data) {
    return {
        type: ICONS,
        data
    }
};

export function getIconsSuccess(data) {
    return {
        type: ICONS_SUCCESS,
        data
    }
};

export function getIconsError(data) {
    return {
        type: ICONS_ERROR,
        data
    }
};

export function GetIcons(data) {
    return dispatch => {
        dispatch(getIcons());
        
        fetch(API_URL+'icons',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getIconsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getIconsError(error));

            })
    }
};
//#endregion
//#endregion